import React from 'react'
import PropTypes from 'prop-types'

import { Feed, Icon } from 'semantic-ui-react'

const DebugFeedSuccess = props => {
  const { success } = props

  if (success) {
    return (
      <Feed.Meta>
        <Feed.Like as="span">
          <Icon color="green" name="checkmark" />
          The update was successful.
        </Feed.Like>
      </Feed.Meta>
    )
  }

  return (
    <Feed.Meta>
      <Feed.Like as="span">
        <Icon color="red" name="x" />
        The update was not successful.
      </Feed.Like>
    </Feed.Meta>
  )
}

DebugFeedSuccess.propTypes = {
  success: PropTypes.bool,
}

DebugFeedSuccess.defaultProps = {
  success: false,
}

export default DebugFeedSuccess
